import React, {Fragment, useContext} from 'react';
import PropTypes from 'prop-types';
import {Button, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import ModalContext from '../../../../fgs/context/ModalContext';

const ApproveItemsModalContent = (props) => {
  const {
    doApproveDocuments,
    selectedItems,
  } = props;

  const {
    toggle,
  } = useContext(ModalContext);

  const onAction = () => {
    doApproveDocuments(selectedItems.map(item => item.id));
    toggle();
  };


  return (
    <Fragment>
      <ModalHeader>
        Aprovar arquivos
      </ModalHeader>
      <ModalBody>
        Tem certeza que deseja APROVAR {selectedItems.length} arquivo(s) ?
      </ModalBody>
      <ModalFooter>
        <Button color="success" onClick={onAction}>Sim, Aprovar</Button>{' '}
        <Button color="secondary" onClick={toggle}>Cancelar</Button>
      </ModalFooter>
    </Fragment>
  );
};

ApproveItemsModalContent.propTypes = {
  selectedItems: PropTypes.array.isRequired,
  doApproveDocuments: PropTypes.func.isRequired,
};

export default ApproveItemsModalContent;
